module.exports = __webpack_public_path__ + "img/help-white-solid.496b8099.svg";